import { WxRadio } from "../..";
import {
  Sorting,
  useFiltersContext,
} from "../../../hooks/context/useFiltersContext";

interface Props {
  sort: { value: Sorting; key: string };
}

export const SortingFilter = ({ sort }: Props) => {
  const { setSorting, sorting } = useFiltersContext();

  return (
    <WxRadio
      key={`sort-${sort.value}`}
      label={sort.key}
      value={sort.value ?? ""}
      radioName={"sorting"}
      selected={sorting === sort.value}
      allowUnselect
      onChange={() => {
        sorting === sort.value ? setSorting(undefined) : setSorting(sort.value);
      }}
    />
  );
};
